import AuthHeader from "@/features/auth/components/AuthHeader";
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import { EventType } from "@/features/events/types/EventType";
import AuthPageLayout from "@/features/platform-layout/components/AuthPageLayout";
import { LoadingOverlay } from "@/features/shared/components/Loaders";
import { useEffect } from "react";
import { useRegistration } from "../hooks/useRegistration";
import RegistrationBox from "./RegistrationBox";

const Registration = () => {

    const { emailError, isLoading, handleInputsSubmit, onBackButtonClick } = useRegistration()
    const { sendEvent } = useCreateEvent()

    useEffect(() => {
        void sendEvent({
            event: EventType.PAGE_VIEW,
            sub_category: "registration_page",
        })
    }, [])

    // ****************************************************************************************

    return (
        <AuthPageLayout>
            <AuthHeader onBackClick={onBackButtonClick} />
            <div className="w-full flex-1 flex flex-col items-center justify-center mt-[80px] overflow-hidden ">
                <div className="w-full sm:w-[328px] md:w-[400px] lg:w-[500px] p-[20px] bg-white">
                    <RegistrationBox
                        onSubmit={handleInputsSubmit}
                        emailError={emailError}
                    />
                </div>
            </div>
            {
                isLoading && <LoadingOverlay />
            }
        </AuthPageLayout>
    )
}

export default Registration
